import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  margin-top: 24px;
  &:hover {
    background: ${({ theme }) => theme.colors.secondary};
    color: #232323;
  }
`;

interface RandomAssignButtonProps {
  onClick: () => void;
}

const RandomAssignButton: React.FC<RandomAssignButtonProps> = ({ onClick }) => (
  <Button onClick={onClick}>랜덤 배치</Button>
);

export default RandomAssignButton; 